define('TescoMobile_Customer/js/view/form/additional-link',['uiComponent', 'mage/url'], function (Component, url) {
  'use strict';

  return Component.extend({
    getUrl: function () {
      if (typeof this.url !== 'undefined') {
        return this.url;
      }
      return typeof this.path !== 'undefined' ? url.build(this.path) : '#';
    }
  });
});

